import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThunder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconThunder"><Path d="M16.8541 1.99652C17.106 1.22427 16.7267 0.544536 16.1739 0.220056C15.6228 -0.103516 14.8457 -0.107425 14.2794 0.466479L3.44297 11.4489C2.47583 12.4291 3.20433 14.0354 4.54857 14.0354H9.74581L7.14593 22.0038C6.89397 22.7761 7.27332 23.4558 7.82605 23.7803C8.37724 24.1039 9.15429 24.1078 9.72056 23.5339L20.557 12.5514C21.5242 11.5713 20.7957 9.96498 19.4514 9.96498H14.2542L16.8541 1.99652Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThunder;
